/// <reference path="../types/index.d.ts" />

import '../client_forms/hanks/style.css';
import FormStructure from './hanks/form_structure';

export default FormStructure;